const dictionary = {
    'Chat': 'Чат',
    'Questions': 'Вопросы',
    'Write a message': 'Напишите сообщение',
    'Answer': 'Ответить',
    'Delete': 'Удалить',
    'This is a question': 'Это вопрос',
    'This is not a question': 'Это не вопрос',
    'Important message': 'Важное сообщение',
    'Unimportant message': 'Неважное сообщение',
    'Ban': 'Бан',
    'New messages': 'Новые сообщения',
    'Registration required': 'Необходима регистрация',
}

export function localize(text, lang) {
    if (lang === "en") return text

    return dictionary[text]
}
